import React from 'react';
import {connect} from "react-redux";
import Popup from "../../index";
import {videoPopup} from "../../../../../actions/popupActions";
import './index.css';

class VideoPopup extends React.Component {

    constructor(props) {
        super(props);
        this.closeVideoPopup = this.closeVideoPopup.bind(this);
    }

    closeVideoPopup () {
        this.props.setVideoPopup(null);
    }

    render() {
        return (
            <Popup className="video-popup popup-large p-4 text-center" onClose={this.closeVideoPopup}>
                <iframe src={`https://www.youtube.com/embed/${this.props.videoId}?autoplay=1`}
                        title="Share Google Contacts with Other Gmail and Google Workspace Users | Shared Contacts for Gmail®" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
            </Popup>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setVideoPopup : (string) => {
            dispatch(videoPopup(string))
        }
    }
};

export default connect(null, mapDispatchToProps)(VideoPopup);
